export const DRAWER_WIDTH = 240;
export const PRICE_DESCRIPTION_FONT_SIZE = 16;

export default {
  DRAWER_WIDTH,
  PRICE_DESCRIPTION_FONT_SIZE,
};
